import { Body } from '@panwds/react-ui'
import { PlusCircleIcon } from '@panwds/icons'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { indexArray } from '../../../common/utils/Utils'
import {
  ERROR_TSG_ALREADY_HAS_CGX,
  ERROR_TSG_ALREADY_HAS_PANORAMA, ERROR_TSG_HAS_PAN_CHINA,
  SASE_SELECT_ACCOUNT
} from '../../constants/LabelConstants'
import SubscriptionService from '../../services/SubscriptionService'
import {
  ADD_NEW, CREATE_NEW,
  CSP_ACCOUNT, CURRENT_TENANT,
  PARENTS_TENANT,
  TENANT_SELECTION_CSP_DESC,
  TENANT_SELECTION_TSG_DESC
} from '../constants/SubscriptionConstant'
import { DATA_TEST_TENANT_SELECTION_CSP, DATA_TEST_TENANT_SELECTION_TSG } from '../constants/TestingDataIds'
import DropDown from '../dropdown/DropDown'
import {
  APP_ID_PAN_CHINA,
  APP_ID_PRISMA_ACCESS_EDITION,
  APP_ID_PRISMA_ACCESS_EDITION_ONPREM, APP_ID_PRISMA_ACCESS_PANORAMA,
  APP_ID_SDWAN
} from '../../../common/constants/GlobalConstants'


/*
 * Created By sswaminathan
 * Created on Mon Nov 22 2021
 * Created on TenantSelection.js
 * Copyright (c) 2021  ©Palo Alto Networks
 */



const TenantSelection = (props) => {
  const { cspDropDownData, selectedTreeNode, currentTsg, flattenTree, sgKeyBy,
    tsgDropDownDetails, lockedTsg, showCspDropDown, setDisabled, licenseDetails, ...rest } = props
  const { setValue, setError } = useFormContext()
  const [tsgDetails, setTsgDetails] = useState([])
  const { cgxRootTSGS, row } = rest
  useEffect(() => {
    if (showCspDropDown) {
      const addNewValue = {
        value: CREATE_NEW,
        description: CREATE_NEW,
        desc: cspDropDownData.length ? cspDropDownData[0].description : '',
        iconLeft: <PlusCircleIcon size='sm' className='cm-text-blue-600' />,
        key: ADD_NEW
      }
      setTsgDetails((prev) => {
        const tsgInfo = lockedTsg ? [...tsgDropDownDetails].filter(each => each.key === lockedTsg) : [...tsgDropDownDetails]
        return lockedTsg ? tsgInfo : [addNewValue, ...tsgInfo]
      })
    }
    else {
      const removeCurrentNode = tsgDropDownDetails?.filter((elem) => {
        return elem.key !== currentTsg
      })
      setTsgDetails((prev) => {
        return removeCurrentNode ? [...removeCurrentNode] : prev
      })
    }
  }, [cgxRootTSGS, cspDropDownData, currentTsg, lockedTsg, row?.values?.primary_product_name, selectedTreeNode?.id, showCspDropDown, tsgDropDownDetails])

  const getCurrentView = useCallback((item) => {
    return (
      <div
        className='tw-flex tw-flex-col'>
        {item.key === selectedTreeNode?.id && <div><Body addClassName='current_tenant' appearance='secondary' >{CURRENT_TENANT}</Body></div>}
        <div><Body addClassName='tw-truncate'>{item.description}</Body></div>
      </div>
    )
  }, [selectedTreeNode?.id])
  useEffect(() => {
    setValue('tsgId', {})
  }, [tsgDetails, setValue, cspDropDownData])

  useEffect(() => {
    if (showCspDropDown) {
      setValue('cspAccount', cspDropDownData ? cspDropDownData[0] : [])
    }
  }, [cspDropDownData, showCspDropDown, setValue])

  const updateTSGDropDown = useCallback((value) => {
    const addNewValue = {
      value: CREATE_NEW,
      description: CREATE_NEW,
      desc: value.target.value.description,
      iconLeft: <PlusCircleIcon size='sm' className='cm-text-blue-600' />,
      key: ADD_NEW
    }
    setTsgDetails([addNewValue, ...tsgDropDownDetails])
    setValue('tsgId', {})
  }, [setValue, tsgDropDownDetails])

  const isPASDWANAddon = useCallback(() => {
    if (row?.original) {
      const hash = row?.original?.hash
      const findLicense = licenseDetails?.find(each => each.hash === hash)?.licenses?.find(each => each.app_id === APP_ID_PRISMA_ACCESS_EDITION)
      return findLicense?.entitlements?.some(each => each.app_id === APP_ID_SDWAN)
    }
    return false
  }, [row, licenseDetails])

  const verifySDWANRootTenant = useCallback(async (value) => {
    const tsg_id = value?.target?.value?.key
    let errorMsg = ''
    // to stop PA license claim on the Panorama
    const hash = rest?.row?.original?.hash
    const filterLicenseByHash = licenseDetails?.find(each => each.hash === hash)?.licenses
    if (showCspDropDown && tsg_id !== ADD_NEW) {
      const { data } = await SubscriptionService.instances.list({ tsg_id })
      const groupByAppId = indexArray(data, 'app_id')
      if ((groupByAppId?.get(APP_ID_PRISMA_ACCESS_EDITION_ONPREM) || groupByAppId?.get(APP_ID_PRISMA_ACCESS_PANORAMA)) &&
        (filterLicenseByHash?.find(_each => _each.app_id === APP_ID_PRISMA_ACCESS_EDITION))) {
        errorMsg = ERROR_TSG_ALREADY_HAS_PANORAMA
      }
      const paeLicenseInformation = groupByAppId?.get(APP_ID_PRISMA_ACCESS_EDITION_ONPREM) ?? groupByAppId?.get(APP_ID_PRISMA_ACCESS_EDITION)
      if (paeLicenseInformation?.entitlements.find(each => each.app_id === APP_ID_PAN_CHINA)) {
        errorMsg = ERROR_TSG_HAS_PAN_CHINA
      }
    }
    if (row?.values?.primary_product_name.includes(APP_ID_SDWAN) || isPASDWANAddon()) {
      if (cgxRootTSGS.includes(value.target.value.key)) {
        errorMsg = ERROR_TSG_ALREADY_HAS_CGX
      }
    }
    if (errorMsg?.length) {
      setError('tsgId', { type: 'focus', message: errorMsg }, { shouldFocus: true })
      setDisabled(true)
    }
    else {
      setError('tsgId', '')
      setDisabled(false)
    }
  }, [rest?.row?.original?.hash, licenseDetails, showCspDropDown, row?.values?.primary_product_name, isPASDWANAddon, cgxRootTSGS, setError, setDisabled])

  const getChild = useMemo(() => {
    return <div
      className="tw-pl-6 tw-pr-6">
      {showCspDropDown && <div>
        <DropDown
          addClassName='cmm-modal-select'
          itemList={cspDropDownData}
          dataTestId={DATA_TEST_TENANT_SELECTION_CSP}
          fieldName='cspAccount'
          label={CSP_ACCOUNT}
          disable={lockedTsg}
          width='350px'
          height='40px'
          selectProps={{
            label: SASE_SELECT_ACCOUNT,
            showLabel: false,
            enableSearch: true,
            fullWidth: true,
          }}
          changeHandler={updateTSGDropDown}/>
        <Body
          size="sm"
          appearance="secondary">
          {TENANT_SELECTION_CSP_DESC}
        </Body>
      </div>}
      <div
        className={showCspDropDown ? 'tw-py-2' : 'tw-pt-16 tw-pl-4 tw-pr-2'}>
        <DropDown
          addClassName='cmm-modal-select'
          itemList={tsgDetails}
          dataTestId={DATA_TEST_TENANT_SELECTION_TSG}
          fieldName='tsgId'
          label={PARENTS_TENANT}
          customDropDown={true}
          creatNewOption={lockedTsg ? false : showCspDropDown}
          changeHandler={verifySDWANRootTenant}
          disable={lockedTsg}
          createDisplay={'[Create New]'}
          selectProps={{
            label: SASE_SELECT_ACCOUNT,
            showLabel: false,
            enableSearch: true,
            fullWidth: true,
            formatOption: {
              view: getCurrentView
            } }}
          width={showCspDropDown ? '350px' : '313px'}
          height={showCspDropDown ? '40px' : '32px'}/>
        <Body
          size="sm"
          appearance="secondary">
          {TENANT_SELECTION_TSG_DESC}
        </Body>
      </div>
    </div>
  }, [showCspDropDown, cspDropDownData, lockedTsg, updateTSGDropDown, tsgDetails, verifySDWANRootTenant, getCurrentView])
  return <div>{ getChild } </div>
}

export default TenantSelection
